import { AuthenticationDetails, CognitoUser, CognitoUserAttribute, CognitoUserPool } from "amazon-cognito-identity-js";
import AWS, { CognitoIdentityCredentials, Credentials } from "aws-sdk";
import { handleResponse } from "../../common/handleLambdaResponse";
import { message } from "antd";

export const checkLogin = (inUserName: string, password: string) => {
    return new Promise((resolve, reject) => {
        const userPool = new CognitoUserPool({
            UserPoolId: process.env.REACT_APP_USER_POOL_ID as string,
            ClientId: process.env.REACT_APP_CLIENT_ID as string,
        });

        const authenticationData = {
            Username: inUserName,
            Password: password,
        };

        const authenticationDetails = new AuthenticationDetails(authenticationData);

        const userData = {
            Username: inUserName,
            Pool: userPool,
        };

        const cognitoUser = new CognitoUser(userData);



        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: (result) => {
                cognitoUser.getSession(function (err: any, session: any) {
                    if (err) {
                        reject("Session error");
                    } else {
                        resolve(true);
                    }
                });
            },
            onFailure: (error) => {
                reject(error);
            },

        });
    });
}

export const  checkSession = () => {
    return new Promise((resolve, reject) => {
        getIdToken().then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    });
}

export const getIdToken = (): Promise<string> => {
    return new Promise((resolve, reject) => {
        const userPool = new CognitoUserPool({
            UserPoolId: process.env.REACT_APP_USER_POOL_ID as string,
            ClientId: process.env.REACT_APP_CLIENT_ID as string,
        });

        const cognitoUser = userPool.getCurrentUser();

        if(!cognitoUser) {
            reject("No user found");
            return;
        }
        cognitoUser.getSession((err: any, session: any) => {
            if (err) {
                reject("Session error");
                return;
            }
            if(!session) {
                reject("No session available")
                return;
            }
             
            const idToken: string = session.getIdToken().getJwtToken();
            if (!AWS.config.credentials) {
                AWS.config.region = process.env.REACT_APP_REGION as string;
            }
            let refresh = !AWS.config.credentials
            if (AWS.config.credentials instanceof AWS.Credentials) {
                if(AWS.config.credentials.needsRefresh()) {
                    refresh = true;
                }
            }
            if(!refresh) {
                resolve(idToken);
                return;
            }
            let loginMap: { [key: string]: string } = {};
            loginMap["cognito-idp." + process.env.REACT_APP_REGION + ".amazonaws.com/" + process.env.REACT_APP_USER_POOL_ID] =
                idToken;
            AWS.config.credentials = new CognitoIdentityCredentials({
                IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID || '',
                Logins: loginMap,
            });
            const credentials = AWS.config.credentials as Credentials;
            credentials.refresh((error) => {
                if (err) {
                    reject("Error refreshing credentials");
                    return;
                }

                // TODO: temporary fix for the issue with the credentials not being refreshed
                setTimeout(() => {
                    setupLambda(idToken).then(() => {
                        resolve(idToken);
                    }).catch((err) => {
                        reject("Error setting up lambda");
                    });
                }, 500);
            }
            );

        });
    });
}

export const logOutUser = () => {
    return new Promise((resolve, reject) => {
        const userPool = new CognitoUserPool({
            UserPoolId: process.env.REACT_APP_USER_POOL_ID as string,
            ClientId: process.env.REACT_APP_CLIENT_ID as string,
        });
        const cognitoUser = userPool.getCurrentUser();

        if (cognitoUser) {
            cognitoUser.signOut();
            resolve("Sign out successful")
        }
        resolve("No user found")
    })
}

export const setupLambda = (idToken : string) => {
    return new Promise(async (resolve, reject) => {
        window.lambda = new AWS.Lambda();
        window.aws_s3 = new AWS.S3();



        const params = {
            FunctionName: "lambda-permission-requestor",
            Payload: JSON.stringify({
                token: idToken
            }),
        };
        AWS.config.region = 'us-west-1';
        window.lambda.invoke(params, (err, resultData: any) => {
            handleResponse(err, resultData, (resp) => {
                let region = AWS.config.region
                let accessKeyId = JSON.parse(resp).AccessKeyId
                let secretAccessKey = JSON.parse(resp).SecretAccessKey
                let sessionToken = JSON.parse(resp).SessionToken
                window.aws_s3 = new AWS.S3({
                    accessKeyId,
                    secretAccessKey,
                    sessionToken,
                    region
                });
                window.lambda = new AWS.Lambda({
                    accessKeyId,
                    secretAccessKey,
                    sessionToken,
                    region
                });
                resolve(true);
            }, (e) => {
                message.error("Error setting up lambda. Please refresh the page.");
                reject(e);
            });
        });
    });
}

export const signUpWithCognito = (inUserName: string, password: string) => {
    return new Promise((resolve, reject) => {
        const userPool = new CognitoUserPool({
            UserPoolId: process.env.REACT_APP_USER_POOL_ID as string,
            ClientId: process.env.REACT_APP_CLIENT_ID as string,
        });

        const attributeList = [
            new CognitoUserAttribute({ Name: 'email', Value: inUserName }),
            new CognitoUserAttribute({ Name: 'name', Value: inUserName }),
        ];

        userPool.signUp(inUserName, password, attributeList, [], (err, result) => {
            if (err) {
                reject(err);
                return;
            }
            resolve(result);
        });
    });
}

export const signUpConfirmCode = (inUserName: string, code: string) => {
    return new Promise((resolve, reject) => {
        const userPool = new CognitoUserPool({
            UserPoolId: process.env.REACT_APP_USER_POOL_ID as string,
            ClientId: process.env.REACT_APP_CLIENT_ID as string,
        });
        const cognitoUser = new CognitoUser({ Username: inUserName, Pool: userPool });
        if(!cognitoUser) {
            reject("User not found!");
        }

        cognitoUser.confirmRegistration(code, true, (err, result) => {
            if (err) {
                reject(err);
                return;
            }
            resolve(result);
        });
    });
}

export const resetPasswordCognito = (inUserMail: string) => {
    return new Promise((resolve, reject) => {
        const userPool = new CognitoUserPool({
            UserPoolId: process.env.REACT_APP_USER_POOL_ID as string,
            ClientId: process.env.REACT_APP_CLIENT_ID as string,
        });
        const cognitoUser = new CognitoUser({ Username: inUserMail, Pool: userPool });
        if (!cognitoUser) {
            reject("User not found!");
        }
        cognitoUser.forgotPassword({
            onSuccess: function (result) {
                resolve(result);
            },
            onFailure: function (err) {
                reject(err);
            },
        });
    });
}
export const confirmPasswordReset = (inUserMail: string, code: string, password: string) => {
    return new Promise((resolve, reject) => {
        const userPool = new CognitoUserPool({
            UserPoolId: process.env.REACT_APP_USER_POOL_ID as string,
            ClientId: process.env.REACT_APP_CLIENT_ID as string,
        });
        const cognitoUser = new CognitoUser({ Username: inUserMail, Pool: userPool });
        if (!cognitoUser) {
            reject("User not found!");
        }
        cognitoUser.confirmPassword(code, password, {
            onSuccess: function (result) {
                resolve(result);
            },
            onFailure: function (err) {
                reject(err);
            },
        });
    });
}

export const getCurrentUserEmail = () => {
    return new Promise((resolve, reject) => {
        const userPool = new CognitoUserPool({
            UserPoolId: process.env.REACT_APP_USER_POOL_ID as string,
            ClientId: process.env.REACT_APP_CLIENT_ID as string,
        });

        const cognitoUser = userPool.getCurrentUser();
        if (!cognitoUser) {
            reject("No user found");
            return;
        }

        cognitoUser.getSession((err: any, session: any) => {
            if (err) {
                reject("Session error");
                return;
            }
            if (!session) {
                reject("No session available")
                return;
            }
            cognitoUser.getUserAttributes((err, attributes) => {
                if (err) {
                    reject(err);
                    return
                }
                // Get email
                const email = attributes?.find((attr) => attr.getName() === "email")?.getValue();
                resolve(email);
            })
        })
    })
}

export const resendVerificationCode = (inUserName: string) => {
    return new Promise((resolve, reject) => {
        const userPool = new CognitoUserPool({
            UserPoolId: process.env.REACT_APP_USER_POOL_ID as string,
            ClientId: process.env.REACT_APP_CLIENT_ID as string,
        });

        const cognitoUser = new CognitoUser({ Username: inUserName, Pool: userPool });
        if (!cognitoUser) {
            reject("User not found!");
        }
        cognitoUser.resendConfirmationCode((err, result) => {
            if (err) {
                reject(err);
                return;
            }
            resolve(result);
        });
    });
}